<template>
  <div class="text-center mt-5">
    <h1 class="mt-5">
      <font-awesome-icon icon="info-circle" class="text-primary h1"/>
    </h1>
    <h2 class="mt-4">We'll be back soon</h2>
    <br>
    <h5>Sorry for the inconvenience, but we're performing some maintenance at the moment.</h5>
    <h5>We'll be back online shortly.</h5>
  </div>
</template>

<script>

  import piincHttp from '@/util/configureAxios.js'

  export default {
    name: 'MaintenancePage',
    data() {
      return {

      };
    },
    components: {

    },
    methods: {

    },
    created() {

    }
  }

</script>
